import { CALCULATOR_TYPE } from '@sbercloud/uikit-product-calculator';
import { SectionBasic } from '@sbercloud/uikit-product-site-section';
import { CalculatorProps } from 'src/components/Calculator';
import { CalculatorSite } from 'src/components/CalculatorSite';

import { useLayoutType } from '../../../hooks/useLayoutType';
import s from './CalculatorProduct.module.scss';

interface CalculatorProductProps extends CalculatorProps {
  title: string;
  subtitle?: string;
  className?: string;
}

export function CalculatorProduct({
  title,
  subtitle,
  initialActiveProduct,
  calculatorType = CALCULATOR_TYPE.Product,
}: CalculatorProductProps) {
  const layoutType = useLayoutType();

  return (
    <SectionBasic
      title={title}
      description={subtitle}
      layoutType={layoutType}
      backgroundColor="neutral-background"
      data-test-id="section-calculator"
    >
      <CalculatorSite
        className={s.calculatorUiKit}
        initialActiveProduct={initialActiveProduct}
        calculatorType={calculatorType}
      />
    </SectionBasic>
  );
}
